<template>
  <div class="page-wrapper">
    <div class="list">
      <!-- 文章栏目 -->
      <div class="article-list" v-if="type == 1">
          <NewsList v-if="list" :list="list" :type="3" :columnId="id" />
      </div>

      <!-- 分类栏目-外链 -->
      <div class="H5-list" v-if="type == 3">
          <NewsList v-if="list" :list="list" :isActivity="true" />
      </div>

      <!-- 所有专题 -->
      <div class="subject-list" v-if="type == 4">
          <div class="subject-message">
              <div class="subject-message-title">所有专题</div>
          </div>
          <NewsList v-if="subjectList" :list="subjectList" :isSubjectList="true" :type="2" :subjectId="id" />
      </div>

      <!-- 专题详情含分类，点击查看更多-跳转-显示列表 -->
      <div class="subject-kind-list" v-if="type == 5">
          <div class="subject-topImg">
              <div class="img" :style="{'background-image': 'url('+topImg+')'}">
                <img style="opacity: 0" :src="topImg" :onerror="errorTopImg">
              </div>
          </div>
          <div class="classify-title">{{kindName}}</div>
          <NewsList v-if="list" :list="list" :type="2" :subjectId="id" :skId="skId" />
      </div>

      <!-- 专题或专栏集合栏目 -->
      <div class="subject-list" v-if="type == 6">
          <NewsList v-if="list" :list="list" :isSubjectList="true" />
      </div>

      <div v-show="isLoading || lastDataId == -1 || subjectLastId == -1 || subjectKindLastId == -1" class="loadMore">
        {{(lastDataId == -1 || subjectLastId == -1 || subjectKindLastId == -1) ? '已经到底了' : '加载更多...'}}
      </div>
    </div>
    <div class="wap-list">
    </div>
  </div>
</template>
<script>
import NewsList from "@/components/NewsList";
import { mapState, mapMutations } from 'vuex';
export default {
  name: "subjectResult",
  data() {
    return {
      page: 1,
      list: [],
      isLoading: false,
      type: null, // 1-栏目文章列表 3-H5列表 4-所有专题 5-分类专题列表 6-专题专栏集合栏目
      id: null, // type == 5 --- 专题id，其他情况代表栏目id
      skId: null, // 专题分类列表id
      lastDataId: null, // 1,3,6 文章，H5，专题专栏集合栏目
      subjectList: null,
      subjectLastId: null, // 4 专题
      subjectKindLastId: null, // 5 分类专题新闻列表lastId
      topImg: null, // 专题分类头图
      kindName: '', // 专题分类名称
      imgLoaded: `this.style.background = 'none'`,
      errorImg: 'this.src="'+ require('./../assets/img/default.png') + '"',
      errorTopImg: `this.parentNode.style.backgroundImage = 'url("${require('./../assets/img/default.png')}")'`, // 分类专题头图加载失败

      channelId: null,
      channelType: null,
    };
  },
  components: {
    NewsList
  },
  created() {
    this.type = this.$route.params.type;
    this.id = this.$route.params.id;
    this.skId = this.$route.params.skId;
    this.getTitle(); // document.title
    this.getData(true); // 为true代表第一次请求
  },
  mounted() {
    this.isPhone && this.$Common.onShare({
      shareUrl: window.location.href
    })
  },
  methods: {
    ...mapMutations(['setLoadingShow']),
    getData(flag) {
        if(this.lastDataId == -1 || this.subjectLastId == -1 || this.subjectKindLastId == -1) {
          return;
        }
        if(this.isLoading) {
          return;
        }
        this.isLoading = true;
        if(this.type == 1) {
          this.getColumnNews(flag);
        } 
        else if(this.type == 3) {
          this.getGroupList(flag);
        } 
        else if(this.type == 4) {
          this.getSubjects(flag);
        } 
        else if(this.type == 5) {
          this.getSubjectNews(flag);
        } 
        else if(this.type == 6) {
          this.getColumnSubjects(flag)
        }
    },
    getColumnNews(flag) {
      if(this.lastDataId == -1 || !this.$Common.Base64.decode(this.id)) {
        return;
      }
      this.$axios.post(
        this.$ApiInfo.getColumnNews,
        {
          page: this.page,
          pageSize: this.pageSize,
          lastDataId: this.lastDataId,
          columnId: this.$Common.Base64.decode(this.id) // 栏目id
        }
      ).then(data => {
        this.lastDataId = data.lastDataId;
        this.page++;
        this.list.push(...data.list);
        this.isLoading = false;
        flag && this.setLoaing()
      })
    },
    getGroupList(flag) {
      if(this.lastDataId == -1 || !this.$Common.Base64.decode(this.id)) {
        return;
      }
      this.$axios.post(
        this.$ApiInfo.getGroupList,
        {
          columnId: this.$Common.Base64.decode(this.id) // 栏目id
        }
      ).then(data => {
        this.lastDataId = -1;
        data && data.length && this.list.push(...data);
        this.isLoading = false;
        flag && this.setLoaing()
      })
    },
    getSubjects(flag) {
      if(this.subjectLastId == -1) {
        return;
      }
      this.$axios.post(
        this.$ApiInfo.getSubjects,
        {
          page: this.page,
          pageSize: this.pageSize,
          lastDataId: this.subjectLastId
        }
      ).then(data => {
        this.subjectLastId = data.lastDataId;
        this.page++;
        data.list && data.list.length && (this.subjectList = data.list);
        this.isLoading = false;
        flag && this.setLoaing()
      })
    },
    getSubjectNews(flag) {
      if(this.subjectKindLastId == -1 || !this.$Common.Base64.decode(this.id) || !this.$Common.Base64.decode(this.skId)) {
        return;
      }
      this.$axios.post(
        this.$ApiInfo.getSubjectDetail,
        {
          id: this.$Common.Base64.decode(this.id),
          skId: this.$Common.Base64.decode(this.skId),
          page: this.page,
          pageSize: this.pageSize,
          skNewsListPageSize: this.pageSize,
          lastDataId: this.subjectKindLastId,
        }
      ).then(data => {
        if(data) {
          data.name && (document.title = data.name);
          data.topImgUrl && (this.topImg = data.topImgUrl);
          if(data.subjectKindList && data.subjectKindList[0]) {
            data.subjectKindList[0].name && (this.kindName = data.subjectKindList[0].name);
            data.subjectKindList[0].newsList && data.subjectKindList[0].newsList.length && (this.list.push(...data.subjectKindList[0].newsList));
            this.subjectKindLastId = data.subjectKindList[0].lastDataId;
            this.page++;
          }
        }
        this.isLoading = false;
        flag && this.setLoaing()
      })
    },
    getColumnSubjects(flag) {
      if(this.lastDataId == -1 || !this.$Common.Base64.decode(this.id)) {
        return;
      }
      this.$axios.get(
        this.$ApiInfo.getColumnSubjects,
        {
          page_size: this.pageSize,
          lastDataId: this.lastDataId,
          column_id: this.$Common.Base64.decode(this.id) // 栏目id
        }
      ).then(data => {
        this.lastDataId = data.lastDataId;
        this.page++;
        this.list.push(...data.list);
        this.isLoading = false;
        flag && this.setLoaing()
      })
    },
    setInit() {
      this.page = 1;
      this.list = [];
      this.isLoading = false;
      this.type = null;
      this.id = null;
      this.skId = null;
      this.lastDataId = null;
      this.subjectList = null;
      this.subjectLastId = null;
      this.subjectKindLastId = null;
      this.topImg = null;
      this.kindName = '';
    },
    getTitle() {
      if(this.$route.params.type == 1 || this.$route.params.type == 3) {
        this.columnList && this.columnList.length && this.columnList.map(v => {
          if(v.id == this.$Common.Base64.decode(this.$route.params.id)) {
            document.title = v.name;
          }
        })
      }
    },
    setLoaing() {
      this.setLoadingShow(false)
      this.$nextTick(() => {
        let footerHeight = 0;
        document.querySelector('.footer-wrapper') && (footerHeight = document.querySelector('.footer-wrapper').clientHeight - 100)
        this.$Common.loadScroll(footerHeight, this.getData);
      })
    }
  },
  computed: {
    ...mapState(['columnList']),
    isPhone() {
        return this.$Common.Attribute.isMb();
    },
    pageSize() {
      return this.isPhone ? 20 : 45;
    },
    colums() {
      return this.columnList;
    },
  },
  watch: {
    $route(val) {
      if(val.params && (val.params.type != this.type || val.params.id != this.id)) {
        this.setInit();
        this.type = val.params.type;
        this.id = val.params.id;
        this.skId = val.params.skId;
        this.getData(true);
        this.getTitle();
      }
    },
    colums(val) {
      if(this.$route.params.type == 1 || this.$route.params.type == 3) {
        val && val.length && val.map(v => {
          if(v.id == this.$Common.Base64.decode(this.$route.params.id)) {
            document.title = v.name;
          }
        })
      }
    }
  },
};
</script>
<style lang="less" scoped>
.subject-kind-list {
  .subject-topImg {
     width: 100%;
        height: auto;
        margin-bottom: 1.5rem;
        .img {
            display: block;
            width: 100%;
            height: 12.75rem;
            background-repeat: no-repeat;
            background-position: center;
            background-size: cover;
            background-image: url('./../assets/img/default.png');
        }
  }
  .classify-title {
      color: #006df1;
      border-left: 0.1875rem solid #006df1;
      text-indent: .5em;
      margin-bottom: 0.875rem;
      line-height: 1.125rem;
      // .title {
      //     float: left;
      // }
  }
}

.wap-wrapper {
  .subject-kind-list {
    .subject-topImg {
      display: none;
    }
    .classify-title {
        display: none;
    }
  }
}
.subject-message {
  margin-top: 0.625rem;
  margin-bottom: 1.5rem;
  color: #fff;
  .subject-message-title {
    font-size: 1.125rem;
    line-height: 1.5625rem;
    border-bottom: 0.125rem solid #fff;
    padding-bottom: 0.25rem;
  }
}
.no-subject-result {
  color: #fff;
}
</style>